var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAsTel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4276 13.9804L11.3831 13.8252C11.9229 13.7382 12.4255 13.4835 12.8102 13.0922L13.6975 12.204C14.1008 11.8002 14.1008 11.148 13.6975 10.7443L11.6561 8.7007C11.2528 8.29696 10.6013 8.29696 10.198 8.7007L8.71506 10.1852L3.82567 5.29061L5.30862 3.80607C5.71193 3.40233 5.71193 2.75012 5.30862 2.34638L3.26724 0.302809C2.86393 -0.100936 2.21243 -0.100936 1.80911 0.302809L0.921826 1.19105C0.530924 1.58237 0.276527 2.07929 0.18966 2.61968L0.0345396 3.57625C-0.101966 4.40237 0.171045 5.24713 0.766706 5.83722L8.15663 13.2351C8.74608 13.8252 9.58994 14.0985 10.4152 13.968L10.4276 13.9804Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAsTel);
export default __webpack_public_path__ + "static/media/icon_as_tel.5c698a18c095f1dd1e72d4853954fca2.svg";
export { ForwardRef as ReactComponent };